import React, {Component} from "react";
import {connect} from "react-redux";
import {translate} from "react-i18nify";

import * as keyCodes from "../../constants/keyCodes";
import * as config from "../../constants/config";
import * as barcodeActions from "../../actions/barcodeActions";
import * as navigationActions from "../../actions/navigationActions";
import * as modelHelper from "../../helpers/modelHelper";

import NumericKeyboardInput from "./NumericKeyboardInput";
import Button from "./generic/Button";
import CloseButton from "./generic/CloseButton";
import Modal from "./generic/Modal";

class BarcodeScanner extends Component {
    timer = null;

    constructor(props) {
        super(props);

        this.state = {
            input: ""
        };
    }

    componentDidUpdate = () => {
        if (this.props.manualScan) {
            window.jQuery("#barcode-scanner-input").focus();
        }
    };

    static getDerivedStateFromProps(nextProps) {
        if (nextProps.manualScan || nextProps.barcode !== "") {
            return null;
        }

        return {
            input: ""
        };
    }

    setScannerInputState = (value) => {
        this.props.dispatchSaveBarcodeAction(value);
        this.setState({input: value});
    };

    closeManualScan = () => {
        this.setState(
            {
                input: ""
            },
            () => this.props.dispatchSaveBarcodeAction(this.state.input)
        );

        this.props.dispatchShowManualScanAction(false);
    };

    timedOut = () => {
        this.setState({
            input: ""
        });
    };

    onBarcodeConfirmClick = () => {
        this.props.dispatchProcessKeyboardEventAction(modelHelper.buildKeyboardEvent("Enter", keyCodes.ENTER));
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleScannerInputChange = (event) => {
        if (!this.props.manualScan) {
            if (this.timer !== null) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(this.timedOut, config.BARCODE_SCANNER_TYPING_LIMIT);
        }

        this.props.dispatchSaveBarcodeAction(event.target.value);
        this.setState({input: event.target.value});
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button label={translate("general.confirm")} onClick={this.onBarcodeConfirmClick} />
                <CloseButton onClick={this.closeManualScan} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={-1}
                className={this.props.manualScan ? "always-on-top" : "off-screen"}
                onClose={this.closeManualScan}
                header={modelHelper.buildModalSection(translate("general.insertBarcode"))}
                content={modelHelper.buildModalSection(
                    <NumericKeyboardInput
                        id="barcode-scanner-input"
                        type="text"
                        className="text-right"
                        value={this.state.input}
                        onFocus={this.handleInputFocus}
                        onChange={this.handleScannerInputChange}
                        extended={false}
                        setInputState={this.setScannerInputState}
                    />
                )}
                footer={this.getFooter()}
                outOfStack={true}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        manualScan: store.barcode.manualScan,
        barcode: store.barcode.barcode
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSaveBarcodeAction: (barcode) => {
            dispatch(barcodeActions.saveBarcode(barcode));
        },
        dispatchShowManualScanAction: (show) => {
            dispatch(barcodeActions.showManualScan(show));
        },
        dispatchProcessKeyboardEventAction: (keyboardEvent) => {
            dispatch(navigationActions.processKeyboardEvent(keyboardEvent));
        }
    };
};

export default BarcodeScanner = connect(mapStoreToProps, mapDispatchToProps)(BarcodeScanner);
